export const menuItems = [
    { to: '/', label: 'Home' },
    { to: '/About', label: 'About' },
    { to: '/Careers', label: 'Careers' },
    { to: '/Services', label: 'Services' },
    { to: '/OurWork', label: 'Our Work' },
    { to: '/Contact', label: 'Contact' },
];
